const addthisInlineElement = $('.addthis_inline_share_toolbox');
const addthisPubID = $('.addthis_inline_share_toolbox').data('pubid');
if(addthisInlineElement.length) {
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.src = "//s7.addthis.com/js/300/addthis_widget.js#pubid=" + addthisPubID;
  $("body").append(s);
}